import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { label: "Leistungen", href: "/#leistungen" },
  { label: "Ablauf", href: "/#ablauf" },
  { label: "Kontakt", href: "/#kontakt" },
];

// Helle Navigation; „Offerte anfragen“ immer sichtbar (auch auf dem Handy). schlicht = nur Logo (Offertanfrage).
export const Navbar = ({ schlicht = false }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 backdrop-blur transition-colors duration-300 ${
        scrolled || open || schlicht ? "bg-stein-50/95 border-b border-stein-300" : "bg-stein-50/80"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <Logo />
        {!schlicht && (
          <>
            <nav className="hidden lg:flex items-center gap-10">
              {LINKS.map((l) => (
                <a key={l.href} href={l.href} className="text-sm font-medium text-stein-700 hover:text-stein-900">
                  {l.label}
                </a>
              ))}
            </nav>
            <div className="flex items-center gap-2">
              <Link
                to="/offerte"
                data-testid="nav-cta-offerte"
                className="whitespace-nowrap px-4 py-2.5 rounded-md bg-chemara-violet text-white text-sm font-semibold hover:bg-chemara-violet-deep transition-colors"
              >
                Offerte anfragen
              </Link>
              <button
                type="button"
                aria-label="Menü"
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
                className="lg:hidden h-10 w-10 grid place-items-center rounded-md border border-stein-300 text-stein-800"
              >
                {open ? <X size={18} /> : <Menu size={18} />}
              </button>
            </div>
          </>
        )}
      </div>
      {open && (
        <div className="lg:hidden border-t border-stein-300 bg-stein-50 px-4 py-2">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-3.5 text-base font-medium text-stein-800 border-b border-stein-200 last:border-0"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};
